<template>
  <div class="page-wrap">
    <div class="top">
      <div style="display: flex">
        <div class="heaer-title">新增维度报表</div>
        <el-button type="primary" @click="downloadFile">导出报表</el-button>
      </div>
      <demension-filter @refreshTable="refreshTable"></demension-filter>
    </div>
    <div class="table">
      <div style="display: flex; margin-bottom: 12px">
        <div class="table-total">共{{ list.length }}条数据</div>
        <el-select v-model="indicator" @change="changeIndicator" class="indicator">
          <el-option
            v-for="item in indicatorList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <demension-table
        ref="usertable"
        :showColumn="showColumn"
        :column="column"
        :list="list"
        :loading="loading"
      ></demension-table>
    </div>
  </div>
</template>
<script>
import demensionFilter from "./demensionFilter.vue";
import demensionTable from "./demensionTable.vue";
import {
  summary_date_table_column,
  summary_country_table_column,
  summary_medio_table_column,
  summary_camp_table_column,
} from "./data";
import { getadddimensiondataFetch } from "@/api/api";
import { indicatorList } from "./data";
export default {
  name: "alldimensionsreport",
  components: { demensionFilter, demensionTable },
  data() {
    return {
      indicatorList,
      loading: false,
      column: summary_date_table_column,
      list: [],
      deleteRoI: "1",
      showColumn: false,
      indicator: "1",
      param: {},
    };
  },
  methods: {
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    changeIndicator() {
      this.refreshTable(this.param);
    },
    refreshTable(param) {
      this.param = param;
      let newColumns = [];
      this.column = [];
      let indicatorColumns = [];
      this.showColumn = false;
      this.loading = true;
      const { dimension, limitDays } = param;
      const indicatorLabel = indicatorList.find((item) => item.value === this.indicator).label;
      for (var i = 0; i < limitDays; i++) {
        indicatorColumns.push({
          key: `${indicatorLabel}${i + 1}`,
          name: `${indicatorLabel}D${i + 1}`,
          sort: true,
          point: 2,
        });
      }
      switch (dimension) {
        case "1":
          newColumns = JSON.parse(JSON.stringify(summary_date_table_column)).concat(
            indicatorColumns
          );
          break;
        case "2":
          newColumns = JSON.parse(JSON.stringify(summary_country_table_column)).concat(
            indicatorColumns
          );
          break;
        case "3":
          newColumns = JSON.parse(JSON.stringify(summary_medio_table_column)).concat(
            indicatorColumns
          );
          break;
        case "4":
          newColumns = JSON.parse(JSON.stringify(summary_camp_table_column)).concat(
            indicatorColumns
          );
          break;
      }
      // 为了解决element表头不更新bug
      setTimeout(() => {
        newColumns.length && (this.column = newColumns);
        this.showColumn = true;
      }, 50);
      this.deleteRoI = dimension;
      this.getData(param);
    },
    getData(param) {
      const { limitDays } = param;
      const listKey = indicatorList.find((item) => item.value === this.indicator).listKey;
      const indicatorLabel = indicatorList.find((item) => item.value === this.indicator).label;
      getadddimensiondataFetch(param)
        .then((res) => {
          this.loading = false;
          const { code, data, msg } = res;
          if (code == "0000") {
            this.list = data.map((item) => {
              for (var i = 0; i < limitDays; i++) {
                item[`${indicatorLabel}${i + 1}`] = item[listKey][i];
              }
              return item;
            });
            console.log(this.list);
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.loading = false;
          throw new Error(e);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: hidden;
  .top {
    padding: 16px 24px 0px 24px;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    background: white;
    box-shadow: 0px 2px 12px #0000001f;
    .heaer-title {
      font-size: 15px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      flex: 1;
    }
  }
  .table {
    box-sizing: border-box;
    margin-right: 16px;
    padding: 24px;
    margin-top: 16px;
    width: 100%;
    border-radius: 4px;
    background: #ffffff;
    box-shadow: 0px 2px 12px #0000001f;
    height: calc(100vh - 210px);
    overflow: hidden;
    .table-total {
      color: #000000d9;
      font-weight: bold;
      font-size: 14px;
      flex: 1;
    }
    .indicator {
      top: -12px;
    }
  }
}
</style>
